$ = jQuery;

$(function() {
  // #reportPostsが存在しない場合は処理しない
  if (!$("#reportPosts").length) {
    return;
  }

  // pressreleaseAjaxDataが存在しない場合は処理しない
  if (typeof pressreleaseAjaxData === 'undefined') {
    return;
  }

  let currentPage = 1;
  let isLoading = false;
  const $moreBtn = $('.more_btn');
  const $archiveContent = $('.archive_content');
  const postsPerPage = 10;

  // 初期読み込み
  loadPressreleasePosts(currentPage);

  // more_btnクリックイベント
  $moreBtn.on('click', function(e) {
    e.preventDefault();
    
    if (isLoading) {
      return;
    }

    isLoading = true;
    currentPage++;
    
    $moreBtn.text('読み込み中...');
    $moreBtn.addClass('loading');

    loadPressreleasePosts(currentPage);
  });

  /**
   * プレスリリース記事をAJAXで読み込む
   * @param {number} page - ページ番号
   */
  function loadPressreleasePosts(page) {
    const $reportPosts = $('#reportPosts');
    
    $.ajax({
      url: ajaxurl,
      type: 'POST',
      data: {
        action: 'load_pressrelease_posts',
        nonce: pressreleaseAjaxData.nonce,
        page: page
      },
      success: function(response) {
        if (response.success && response.data.posts_html) {
          if (page === 1) {
            // 初期読み込み時は#reportPostsに直接追加
            $reportPosts.html(response.data.posts_html);
          } else {
            // 追加読み込み時は追加前の記事数を保存
            const beforeCount = $archiveContent.find('.archive_item').length;
            
            // 記事を追加（more_btnの前に挿入）
            $moreBtn.before(response.data.posts_html);
            
            // 追加された最初の要素を取得
            const $newItems = $archiveContent.find('.archive_item');
            const $firstNewItem = $newItems.eq(beforeCount);
            
            // 追加された最初の要素までスクロール
            if ($firstNewItem.length) {
              const offsetTop = $firstNewItem.offset().top;
              const headerHeight = $('#header').outerHeight() || 0;
              const scrollPosition = offsetTop - headerHeight - 20; // ヘッダー分と余白を引く
              
              $('html, body').animate({
                scrollTop: scrollPosition
              }, 500);
            }
          }
          
          // これ以上記事がない場合はボタンを非表示
          if (!response.data.has_more) {
            $moreBtn.hide();
          } else {
            $moreBtn.text('more');
            $moreBtn.removeClass('loading');
          }
        } else {
          if (page === 1) {
            $reportPosts.html('<p>記事が見つかりませんでした。</p>');
          } else {
            $moreBtn.text('more');
            $moreBtn.removeClass('loading');
            alert('記事の読み込みに失敗しました');
          }
        }
        isLoading = false;
      },
      error: function(xhr, status, error) {
        console.error('AJAX Error:', status, error);
        if (page === 1) {
          $reportPosts.html('<p>記事の読み込みに失敗しました。</p>');
        } else {
          $moreBtn.text('more');
          $moreBtn.removeClass('loading');
          alert('記事の読み込みに失敗しました');
          currentPage--; // ページ番号を戻す
        }
        isLoading = false;
      }
    });
  }

  // #pressReleaseに表示（最新2件）- これは従来通りRSS XMLから直接読み込む
  if ($("#pressRelease").length) {
    let rss = "/wp-content/themes/yaf2025/lib/rss.xml";
    
    $.ajax({
      type: "GET",
      url: rss,
      cache: false,
      dataType: "XML",
      timeout: 5000,
      success: function(xml) {
        let row = 0;
        let data = [];
        let nodeName;
        let attributes;
        
        // XMLからitem要素を取得
        $(xml).find('item').each(function() {
          data[row] = {};
          $(this).children().each(function() {
            nodeName = $(this)[0].nodeName;
            data[row][nodeName] = {};
            attributes = $(this)[0].attributes;
            
            // 属性を取得
            for (let i in attributes) {
              data[row][nodeName][attributes[i].name] = attributes[i].value;
            }
            data[row][nodeName]['text'] = $(this).text();
          });
          row++;
        });
        
        // データを整形してresultsに格納
        let results = [];
        for (let i = 0; i < data.length; i++) {
          let d = new Date(data[i].date.text);
          var formatted = `${d.getFullYear()}.${d.getMonth() + 1}.${d.getDate()}`.replace(/\n|\r/g, '');
          results[i] = {
            title: data[i].title.text,
            link: data[i].link.text,
            date: formatted,
            term: 'プレスリリース'
          };
        }
        
        // 最新2件を表示
        $.each(results, function(i, val) {
          if (i < 2) {
            $("#pressRelease").append(home_posts_dom(val));
          }
        });
      },
      error: function(XMLHttpRequest, textStatus, errorThrown) {
        console.log("XMLHttpRequest : " + XMLHttpRequest.status);
        console.log("textStatus     : " + textStatus);
        console.log("errorThrown    : " + errorThrown.message);
      }
    });
  }

  /**
   * ホームページ用のプレスリリース記事のHTMLを生成
   * @param {object} val - 記事データ（title, link, date, term）
   * @returns {string} 生成されたHTML
   */
  function home_posts_dom(val) {
    let html = "";
    html += "<li class='home__news__list__item'>";
    html += "<a href='" + val.link + "' rel='nofollow' target='_blank' title='" + val.title + "の詳細ページを新規タブで開きます' class='link'>";
    html += "<span class='icon press_release'>プレスリリース</span>";
    html += "<time datetime='" + val.date + "' class='date'>" + val.date + "</time>";
    html += "<h3 class='title press_release'>" + val.title + "</h3>";
    html += "</a>";
    html += "</li>";
    return html;
  }
});
